<template>
  <BaseEmptyState>
    <template v-slot:icon>
      <ExclamationTriangleIcon />
    </template>
    <template v-slot:title>
      <slot name="title">
        <h2>{{ $t('ui.permissions.noPermissionsTitle') }}</h2>
      </slot>
    </template>
    <template v-slot:content>
      <slot name="default">
        <p>{{ $t('ui.permissions.noPermissionsMessage') }}</p>
      </slot>
    </template>
  </BaseEmptyState>
</template>

<script>
import { defineComponent } from 'vue';
import BaseEmptyState from '@/components/library/emptyStates/BaseEmptyState.vue';
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default defineComponent({
  name: 'NoPermissionEmptyState',
  components: {
    BaseEmptyState,
    ExclamationTriangleIcon,
  },
});
</script>
